import React from 'react';

import { TemplateBuilderContext, useTemplateBuilderReducer } from './builder-context';
import { CampaignTemplateWizard } from './wizard';

type CampaignTemplateBuilderProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function CampaignTemplateBuilder({ isOpen, onClose }: CampaignTemplateBuilderProps) {
  const builderReducer = useTemplateBuilderReducer();

  return (
    <TemplateBuilderContext.Provider value={builderReducer}>
      <CampaignTemplateWizard open={isOpen} onClose={onClose} />
    </TemplateBuilderContext.Provider>
  );
}
